// utils/security/pathValidation.ts
/**
 * Checks if a given path is a safe internal route.
 * Prevents open redirect vulnerabilities by ensuring the path is relative and starts with "/".
 */

export function isValidInternalPath(path: string): boolean {
  return typeof path === "string" && path.startsWith("/") && !path.startsWith("//");
}
